<template>
  <div>
    <button
      @click="showMobileMenu = !showMobileMenu"
      :class="['md:hidden mob-btn bg-white', { hidden: showMobileMenu }]"
    >
      <Icon icon="ep:back" />
      Menú
    </button>

    <div
      class="md:grid md:grid-cols-12 md:gap-5 gap-0 p-0 md:p-0 rounded-2xl m-0 mt-0"
    >
      <div :class="['md:block md:col-span-3 md:-ml-12', { hidden: !showMobileMenu }]">
        <div class="lg:px-4 py-5 sections-course bg-white rounded-2xl z-20">
          <div class="flex justify-center">
            <img
              :src="course.icon ? course.icon : '/images/courses/course-1.png'"
              alt=""
              class="h-40 w-40 -ml-2"
            />
          </div>

          <button
            v-if="!this.course.enrolled"
            class="mob-btn mob-cta-gold-outline w-full mt-4 mb-2 text-xl"
            @click="enroll"
          >
            Inscribirse
          </button>

          <MobPaymentModal ref="mobPaymentModal" />

          <MobBaseModal
            ref="mobRollModal"
            modal-id="modal-roll"
            title="¡Felicitaciones!"
            body-text="Tu inscripción al curso ha sido exitosa. ¡Disfruta el aprendizaje!"
            :show-button1="true"
            :show-button2="false"
            button1-text="Cerrar"
            :button1-callback="closeEnrollModal"
          />

          <CourseDetailNavigation
            @navigation="showMobileMenu = !showMobileMenu"
            class="mt-4"
          />
        </div>
      </div>
      <div :class="['md:block md:col-span-9', { hidden: showMobileMenu }]" class="m-0 p-0">
        <div class="md:bg-white h-full m-0 p-0 min-h-0">

          <div
            class="md:bg-white w-full min-w-0 m-0 px-0 py-5 min-h-full"
          >
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import CourseDetailNavigation from "./CourseDetailNavigation.vue";
import { enrollToCourse } from "@/services/courses.service";
import { MobBaseModal } from "@/views/V2/components";
import { MobPaymentModal } from "@/views/V2/components";

export default {
  name: "CourseDetailLayout",
  components: {
    Icon,
    CourseDetailNavigation,
    MobBaseModal,
    MobPaymentModal,
  },
  data() {
    return {
      showMobileMenu: true,
    };
  },
  computed: {
    course : function () {
      return this.$store.state.course.current
    },
    isPremiumUser() {
      return this.$store.state.auth.isPremium;
    },
  },
  methods: {
    async enroll() {
      if (this.course.isPremium && !this.isPremiumUser) {
        this.$refs["mobPaymentModal"].showModalPayment();
      } else if (!this.course.isPremium || this.isPremiumUser) {
        await enrollToCourse(this.course.id);
        this.$refs["mobRollModal"].showModal();
      }
    },
    closeEnrollModal() {
      let course = this.$store.state.course.current;
      this.$router.push(`/course/${course.id}`);
      this.$router.go();
    },
  },
};
</script>
<style scoped>
@media (min-width: 768px) {
  .sections-course {
    margin-top: -220px;
    position: relative;
  }
}
</style>
